import globalMU from 'globalMU'
import React from 'react'
import { ControleColunasMetaBonus, ItemResultadoMetaBonus } from '../../types/MetaBonus'

const estilosPesquisarCliente = require('app/components/pesquisa-cliente/pesquisar-cliente.module.scss').default

type Props = {
    itens: ItemResultadoMetaBonus[]
    controle: ControleColunasMetaBonus
}

const fmt = (valor: number, casas = 2) =>
    globalMU.formatarValorNumerico(valor, casas)

export const ConsultarMetaBonusResultado = ({ itens, controle }: Props) => {

    if (!itens || itens.length === 0) {
        return (
            <div style={{ padding: '16px' }}>
                <span>Nenhum dado encontrado para os filtros informados.</span>
            </div>
        )
    }

    return (
        <div
             id="ConsultarMetaBonusResultado_div"
        >
            <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '60vh' }}>
                <div className={`_table _w-full _border-collapse ${estilosPesquisarCliente.tabelaPesquisaCliente}`}
                    style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                    <div className="_table-header-group"
                        id="ConsultarMetaBonusResultado_divTableGroup"
                    >
                        <div className="_table-row">
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader}`}>Vendedor</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Meta</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Qtd. Venda</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Valor Venda</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Qtd. Devol.</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Valor Devol.</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Qtd. Canc.</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Valor Canc.</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Venda Líquida</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>% Meta</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Prêmio Meta</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Venda Diária</div>
                            {controle.ExibirVendasSemDesconto && (
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Vendas Sem Desconto</div>
                            )}
                            {controle.ExibirValorPremioMetaDesconto && (
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Valor do Prêmio (Meta Desconto)</div>
                            )}
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Saldo de Meta</div>
                            <div className={`_table-cell ${estilosPesquisarCliente.tableCellHeader} _text-right`}>Meta Diária</div>
                        </div>
                    </div>

                    <div className="_table-row-group">
                        {itens.map((item, idx) => (
                            <div key={`${item.CodVend}-${idx}`}
                                id={`ConsultarMetaBonusResultado_div-${item.CodVend}`}
                                className={`_table-row ${estilosPesquisarCliente.linha}`}>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody}`}>
                                    {item.CodVend} - {item.NomeVend}
                                </div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.ValorMeta)}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{item.QtdVenda}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.ValorVenda)}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{item.QtdDevol}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.ValorDevol)}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{item.QtdCancelamento}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.ValCancelamento)}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.VendaLiquida)}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.PercMeta)}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.ValPremio)}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.VendaDiaria)}</div>
                                {controle.ExibirVendasSemDesconto && (
                                    <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.VendasSemDesconto)}</div>
                                )}
                                {controle.ExibirValorPremioMetaDesconto && (
                                    <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.ValorPremioMetaDesconto)}</div>
                                )}
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.SaldoMeta)}</div>
                                <div className={`_table-cell ${estilosPesquisarCliente.tableCellBody} _text-right`}>{fmt(item.MetaDiaria)}</div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            <div style={{ marginTop: '8px', fontSize: '12px', padding: '0 4px' }}>
                {controle.ExibirVendasSemDesconto && (
                    <p><strong>Vendas Sem Desconto</strong> = Vendas Sem Liberação de Desconto Acima do Permitido.</p>
                )}
                {controle.ExibirValorPremioMetaDesconto && (
                    <p><strong>Valor do Prêmio (Meta de Desconto)</strong> = Vendas Sem Desconto Aplicado o Percentual Configurado no Parâmetro <em>"Percentual para premiação de vendas sem desconto"</em>.</p>
                )}
            </div>
        </div>
    )
}